import { gql, useMutation } from '@apollo/client'

export const LOCALIZE_PROJECT = gql`
  mutation ($input: CampaignLocalize) {
    localizeCampaign(input: $input) {
      id
      parent {
        id
      }
      original_campaign_id
      global_status
      __typename
    }
  }
`

export const useLocalize = () => {
  const [mutate, { data, loading, error }] = useMutation(LOCALIZE_PROJECT, {
    update(cache) {
      cache.modify({
        fields: {
          getCampaign() {}
        }
      })
    }
  })

  return { mutate, data, loading, error }
}
